import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/auth';
import { initMetaPixelWithIdentity } from '@/lib/meta-pixel';

/**
 * Re-initialise the Meta Pixel with Advanced Matching (hashed email +
 * Supabase user.id) once an authenticated identity is available. SHA-256
 * hashing happens inside meta-pixel.ts before fbq sees the values — no
 * plaintext PII reaches Meta.
 *
 * Renders nothing. Mount once inside the auth provider tree (App.tsx).
 */
const MetaPixelIdentitySync = () => {
  const { user } = useAuth();
  const lastSentIdentityRef = useRef<string | null>(null);

  useEffect(() => {
    if (!user?.id) return;

    const signature = `${user.id}|${user.email ?? ''}`;
    if (lastSentIdentityRef.current === signature) return;
    lastSentIdentityRef.current = signature;

    void initMetaPixelWithIdentity({
      email: user.email ?? null,
      externalId: user.id,
    });
  }, [user?.id, user?.email]);

  return null;
};

export default MetaPixelIdentitySync;
